import React from 'react';
import Layout from '../components/shared/Layout';
import MetaHead from '../components/shared/MetaHead';

const KontaktPage = () => {
  return (
    <Layout>
      <MetaHead title="Kontakt Hansen-Byg - Østergade 26, 9400 Nørresundby" />

      <h1>Kontakt</h1>
      <p>
        Hansen-Byg
        <br />
        Østergade 26
        <br />
        9400 Nørresundby
      </p>

      <p>
        Tlf: <a href="tel:+4522140087">22140087</a>
        <br />
        Email:{' '}
        <a href="mailto:hansenbyg-bogholderi@outlook.dk">
          hansenbyg-bogholderi@outlook.dk
        </a>
        <br />
        <br />
        CVR: 29857490
      </p>
    </Layout>
  );
};

export default KontaktPage;
